import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { MarketActivityIndicator } from '@market/react';

const useStyles = makeStyles({
  root: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    opacity: ({ delayMs }) => (delayMs ? 0 : 1),
    animationDelay: ({ delayMs }) => `${delayMs}ms`,
    animationDuration: '0s',
    animationFillMode: 'forwards',
    animationName: '$makeVisible',
    animationTimingFunction: 'linear',
  },
  '@keyframes makeVisible': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
});

const PageLoader = (props) => {
  const { delayMs = 0, indicatorStyle = {}, indicatorSize } = props;

  const classes = useStyles({ delayMs });

  const indicatorProps = {
    ...(indicatorSize && { size: indicatorSize }),
    ...(indicatorStyle && { style: indicatorStyle }),
  };

  return (
    <div className={classes.root}>
      <MarketActivityIndicator {...indicatorProps} />
    </div>
  );
};

export default PageLoader;
